import mutations from './mutations';
import actions from './actions';
import getters from './getters';
export const getDefaultUserState = () => {
    return {
        loading: false,
        snackbar: {
            show: false,
            status: '',
            message: ''
        }
    };
};
const state = getDefaultUserState();
export const global = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
